// action-button.component.ts
import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule, NgClass} from '@angular/common';
import {BaseButtonComponent} from './base-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  selector: 'app-page-button',
  template: `
    <app-base-button
      [baseClass]="'w-full bg-theme-surface px-3 py-2 rounded-xl text-theme-secondarybutton text-lg border-2 ' +
                  'border-theme-secondarybutton'"
      [disabled]="disabled"
      (onClick)="onClick.emit($event)"
      stateColorScheme="surface"
    >
      <div class="flex justify-center w-full">
        <div class="flex flex-row items-center">
          <i class="fas text-xl mr-3" [class]="icon"></i>
          <span class="text-center text-lg font-bold">{{ text }}</span>
        </div>
      </div>
    </app-base-button>
  `
})
export class PageButtonComponent {
  @Input() text: string = 'Action';
  @Input() icon: string = 'fa-plus';
  @Input() disabled: boolean = false;
  @Input() selected: boolean = false;
  @Output() onClick = new EventEmitter<MouseEvent>();
}
